import * as types from './actionTypes';

export const update = user => ({
    type: types.UPDATE,
    user
});